import * as React from 'react';
import CustomerSupport from './CustomerSupport.js';
import { useCreateTicket } from './hooks/use-create-ticket.js';
import '@swc/helpers';
import '@grandvisionhq/forms';

const CustomerSupportContainer = (props)=>{
    const [onSubmit, result] = useCreateTicket();
    return /*#__PURE__*/ React.createElement(CustomerSupport, {
        onSubmit: onSubmit,
        isLoading: result.isLoading,
        showErrorMessage: !!result.error,
        showSuccessMessage: result.isSuccessful,
        isCustomerIDActivated: props.isCustomerIDActivated,
        showConsent: props.showConsent
    });
};

export { CustomerSupportContainer as default };
//# sourceMappingURL=CustomerSupportContainer.js.map
